import { ButtonTriggerEvent } from '../../../common/components';

export class ExportPdfModalActions {
  confirm: (event: ButtonTriggerEvent, progressCallback?: (progress) => void) => void;
  cancel?: () => void;
}

export class ExportPdfModalData {
  isApproved: boolean | undefined;
  limit: number;
  page: number;
  from: Date;
  to: Date;
  isManuallyCreated: boolean;
  choice: boolean;
  exportType: 'PDF' | 'CSV';

  isAsync?: boolean;
  isEvent: boolean;
  isPrintVersion: boolean;
  isToBeExport: boolean;
  eventSource: string; // 'all' | 'choice' | 'selected';
  placeSource: string; // 'all' | 'choice' | 'selected';
  category: string;
  categoryList: string[]; // for custom default categories
  source: string;
  convertImgUrl: boolean;
  approvalStatus: string;

  subTitle: string; // showing on the PDF title sub title, similar to event date range
  category_id: string; // get _id from PlaceType in order to fun igURL from placeURLs
}

export class LogoCommand {
  isDefault: boolean;
  url: string;
}

export class PDFSettingCommand {
  pdf: {
    headerImage: {
      event: {
        isDefault: boolean;
        url: string[];
      };
      place: {
        isDefault: boolean;
        url: string[];
      };
      tour: {
        isDefault: boolean;
        url: string;
      };
      trip: {
        isDefault: boolean;
        url: string;
      };
    };
  };
  eventCalendarURL: string;
  placeCalendarURL: string;
  moreToursURL: string;

  constructor() {
    this.pdf = {
      headerImage: {
        event: { isDefault: true, url: null },
        place: { isDefault: true, url: null },
        tour: { isDefault: true, url: null },
        trip: { isDefault: true, url: null },
      },
    };
    this.eventCalendarURL = null;
    this.placeCalendarURL = null;
    this.moreToursURL = null;
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/export.pdf.modal/export.pdf.modal.provider.ts